import { preserveSelection } from 'common/Prose/utils'
import { computed } from 'mobx'
import { toggleMark } from 'prosemirror-commands'
import { MarkType } from 'prosemirror-model'
import { useProseStateContext } from '../ProseStateContext'

export const useMarkToggle = (markType: MarkType) => {
  const state = useProseStateContext()

  if (!state?.view) {
    return {
      isActive: false,
      isDisabled: true,
      onPress: () => {},
    }
  }

  const view = state.view

  const isActive = computed(() => state.activeMarks.has(markType)).get()
  // TODO: check if prosemirror has an utility to automatically calculate
  // compatibility between this mark and the current selection
  const isDisabled = false
  const onPress = () => {
    toggleMark(markType)(view.state, view.dispatch)
    preserveSelection(view.state.tr, view.state)
    view.focus()
  }

  return {
    isActive,
    isDisabled,
    onPress,
  }
}
